import React from "react"
import { Disqus } from "gatsby-plugin-disqus"
import LazyLoad from "react-lazyload"

const LazyDisqus = props => (
  <LazyLoad once>
    <Disqus config={props.config} />
  </LazyLoad>
)

export default LazyDisqus
